import $ from 'jquery';
import { camelCase } from 'lodash';

import {
  SIGNUP_PRE_INTENT_EVENT,
  TRIGGER_SCROLL_TRACKING,
} from '@zapier/tracking';

import { dangerouslyDoNav } from 'app/common/utils/RouterUtils';
import { trackEvent } from 'app/track/trackingFunctions';

// Targets the legacy header/footer element which is still used in Django-land
export const legacyHeaderId = 'header';
export const legacyFooterId = 'footer';

export const bindLegacyEventHandlers = () => {
  // Note that jQuery is used to facilitate event delegation.
  // Otherwise we'd need to `addEventListener` and then look up
  // all of `e.target`'s parent nodes and use `matches` (which
  // has an inconsistent API across browsers anyway) to see if
  // a node was clicked, since `e.target` may be a child of the
  // node we care about. We could also select nodes and `addEventListener`
  // to each of them, but that's of course problematic if nodes
  // are added to the page later.
  const $body = $(document.body);

  $body.on(
    'click',
    '[href="mailto:contact@zapier.com"]:not([data-force="yes"])',
    e => {
      e.preventDefault();
      dangerouslyDoNav(
        `/app/contact-us?from_url=${encodeURIComponent(window.location.href)}`
      );
    }
  );

  // On the old Django homepage, we trigger scroll tracking via GTM
  window.addEventListener('DOMContentLoaded', () => {
    trackEvent(TRIGGER_SCROLL_TRACKING, {
      event: TRIGGER_SCROLL_TRACKING,
      eventLabel: TRIGGER_SCROLL_TRACKING,
    });
  });

  // The below eventListeners are part of old homepage event tracking
  // there are multiple places were the eventListener logic is held, depending on the component
  // 1. Static CTA buttons are managed here
  // 2. The app search page `web/backend/zapier/templates/static/homepage/partials/app-search.html` is managed at `web/frontend/assets/app/homepage/components/HomepageServiceSearch.js`
  // 3. [ALREADY TRACKED BUT WITH DIFFERENT DATA SHAPE] The hero registration page `web/backend/zapier/templates/blocks/register.html` is managed at `web/frontend/assets/app/login/components/LoginForm.js`
  $body.on('click', '#homepage-plan-start-trial', e => {
    trackEvent(SIGNUP_PRE_INTENT_EVENT, {
      ctaName: camelCase(e.currentTarget.innerText),
      path: window.location.pathname,
      referrer: e.currentTarget.baseURI,
      signupFormat: 'link',
      signupPosition: 'section_6',
      link_destination: e.currentTarget.href,
      section: 'homepage_section_pricing',
      section_order: 6,
      cta_order: 4,
    });
  });
  $body.on('click', '#old-homepage-way-goodbye-cta', e => {
    trackEvent(SIGNUP_PRE_INTENT_EVENT, {
      ctaName: camelCase(e.currentTarget.innerText),
      path: window.location.pathname,
      referrer: e.currentTarget.baseURI,
      signupFormat: 'link',
      signupPosition: 'section_8',
      link_destination: e.currentTarget.href,
      section: 'homepage_hero_signup',
      section_order: 8,
      cta_order: 5,
    });
  });
  $body.on('click', '#old-homepage-builtin-apps-cta', e => {
    // the button with #old-homepage-builtin-apps-cta gets reused in many places, so we want to limit the eventListner to only the homepage
    // this lets us accomplish our goal while not have to do a lot of rewiring. eventually we will leave Django altogether
    if (window.location.pathname === '/') {
      trackEvent(SIGNUP_PRE_INTENT_EVENT, {
        ctaName: camelCase(e.currentTarget.innerText),
        path: window.location.pathname,
        referrer: e.currentTarget.baseURI,
        signupFormat: 'link',
        signupPosition: 'section_4',
        link_destination: e.currentTarget.href,
        section: 'homepage_section_border_builtin_apps',
        section_order: 4,
        cta_order: 3,
      });
    }
  });
};
